var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ContextMenu } from 'primereact/contextmenu';
import { Tree } from 'primereact/tree';
import * as React from 'react';
import './DataTree.css';
var DataTree = /** @class */ (function (_super) {
    __extends(DataTree, _super);
    function DataTree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.contextMenuEl = null;
        _this.selectMenuItem = function (event) {
            _this.props.onContexMenutItem(event ? event.value : null);
        };
        return _this;
    }
    DataTree.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, nodeTemplate = _a.nodeTemplate, contextMenu = _a.contextMenu;
        return (React.createElement(React.Fragment, null,
            React.createElement(ContextMenu, { appendTo: document.body, model: contextMenu, ref: function (el) { return _this.contextMenuEl = el; }, onHide: function () { return _this.selectMenuItem(null); } }),
            React.createElement(Tree, { value: data, nodeTemplate: nodeTemplate, onContextMenuSelectionChange: function (event) { return _this.selectMenuItem(event); }, onContextMenu: function (event) { return _this.contextMenuEl.show(event.originalEvent); } })));
    };
    return DataTree;
}(React.Component));
;
export default DataTree;



//////////////////
// WEBPACK FOOTER
// ./src/components/UI/DataTree/DataTree.tsx
// module id = 114
// module chunks = 0